import React, { Component } from 'react';
import {
    Redirect
} from 'react-router-dom';
import Api from '../../../components/shared/api';
import FormError from '../../../components/shared/form-error';
import AppStatusPanel from './app-status-panel';
import AppManagePanel from './app-manage-panel';

class ApplicationDetailApp extends Component {

    constructor() {

        super();
        this.state = {
            application: null,
            providers: [],
            countries: [],
            languages: [],
            redirect: null,
            error: null,
            success: null
        };

        this.updateApplication = this.updateApplication.bind(this);
        this.onDelegateChanged = this.onDelegateChanged.bind(this);
        this.onDelegateWhitelistChanged = this.onDelegateWhitelistChanged.bind(this);
        this.onDelegateWhitelistAdded = this.onDelegateWhitelistAdded.bind(this);
        this.onDelegateWhitelistRemoved = this.onDelegateWhitelistRemoved.bind(this);
        this.onDomainAdded = this.onDomainAdded.bind(this);
        this.onDomainRemoved = this.onDomainRemoved.bind(this);
        this.onChannelIdChanged = this.onChannelIdChanged.bind(this);
        this.onClientSecretReset = this.onClientSecretReset.bind(this);
        this.onDeleteApplication = this.onDeleteApplication.bind(this);
        this.onToggleApplication = this.onToggleApplication.bind(this);
        this.onPrivacyIdChanged = this.onPrivacyIdChanged.bind(this);
        this.onProviderChanged = this.onProviderChanged.bind(this);
        this.onImplicitChange = this.onImplicitChange.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onFailed = this.onFailed.bind(this);
        this.onAppTypeChanged = this.onAppTypeChanged.bind(this);
        this.onLocaleCountryChanged = this.onLocaleCountryChanged.bind(this);
        this.onLocaleDefaultCountryUpdated = this.onLocaleDefaultCountryUpdated.bind(this);
        this.onLocaleLanguageChanged = this.onLocaleLanguageChanged.bind(this);
        this.onLocaleDefaultLanguageUpdated = this.onLocaleDefaultLanguageUpdated.bind(this);
        this.onSmsOptInEnabledChanged = this.onSmsOptInEnabledChanged.bind(this);
        this.onSmsOptInCopyUpdated = this.onSmsOptInCopyUpdated.bind(this);
        this.onPhoneNumberCountryAdded = this.onPhoneNumberCountryAdded.bind(this);
        this.onPhoneNumberCountryRemoved = this.onPhoneNumberCountryRemoved.bind(this);
        this.onEmailOptInEnabledChanged = this.onEmailOptInEnabledChanged.bind(this);
        this.onEmailOptInCopyUpdated = this.onEmailOptInCopyUpdated.bind(this);
        this.onPortalSettingChanged = this.onPortalSettingChanged.bind(this);
        this.onGuestCheckoutEnabledChanged = this.onGuestCheckoutEnabledChanged.bind(this);
        this.onFirstNameEnabledChanged = this.onFirstNameEnabledChanged.bind(this);
        this.onLastNameEnabledChanged = this.onLastNameEnabledChanged.bind(this);
        this.onPhoneNumberEnabledChanged = this.onPhoneNumberEnabledChanged.bind(this);
        this.onHeaderLogoUrlUpdated = this.onHeaderLogoUrlUpdated.bind(this);
        this.onHeaderBackgroundColorUpdated = this.onHeaderBackgroundColorUpdated.bind(this);
        this.onButtonColorUpdated = this.onButtonColorUpdated.bind(this);
        this.onButtonHoverColorUpdated = this.onButtonHoverColorUpdated.bind(this);
        this.onPkceChanged = this.onPkceChanged.bind(this);
        this.onOverrideEmailValidationChanged = this.onOverrideEmailValidationChanged.bind(this);
        this.onPasswordChanged = this.onPasswordChanged.bind(this);
        this.onTermsAndConditionsUpdated = this.onTermsAndConditionsUpdated.bind(this);
        this.onPrivacyPolicyUpdated = this.onPrivacyPolicyUpdated.bind(this);
        this.onTitleUpdated = this.onTitleUpdated.bind(this);
        this.onAppIconUpdated = this.onAppIconUpdated.bind(this);
        this.onMoreInfoUpdated = this.onMoreInfoUpdated.bind(this);
        this.onPermissionAdded = this.onPermissionAdded.bind(this);
        this.onPermissionRemoved = this.onPermissionRemoved.bind(this);
        this.onPassportClientAdded = this.onPassportClientAdded.bind(this);
        this.onPassportClientRemoved = this.onPassportClientRemoved.bind(this);
        this.api = new Api();
        this.oauthApi = new Api('oauth');
    }

    updateApplication(payload, successMessage) {

        this.api.exec(`/user/organizations/${this.props.organizationId}/applications/${this.props.applicationId}`, 'PUT', payload)
            .then((application) => {

                if (application) {
                    if (application.error) {
                        return this.onFailed(application.message);
                    }

                    if (Object.keys(application).length) {
                        this.setState({ application, success: successMessage || null, error: null });
                    }
                }
            })
            .catch((err) => {

                this.onFailed(err.toString());
            });
    }

    onDomainAdded(domain) {

        // if (process.env.REACT_APP_APP_ENV === 'production') {
        //     if (domain.indexOf('https://') !== 0) {
        //         return this.onFailed(`Invalid redirect URL "${domain}": redirects must begin with "https://".`);
        //     }
        // }

        const redirectUrls = this.state.application.redirectUrls.slice();
        redirectUrls.push(domain);

        return this.updateApplication({ redirectUrls });
    }

    onDomainRemoved(domain) {

        const redirectUrls = this.state.application.redirectUrls.slice();
        const index = redirectUrls.findIndex((ru) => { return ru === domain; });
        if (index >= 0) {
            redirectUrls.splice(index, 1);
            return this.updateApplication({ redirectUrls });
        }
    }

    onChannelIdChanged(channelId) {

        return this.updateApplication({ channelId: channelId });
    }

    onClientSecretReset() {

        return this.updateApplication({ clientSecret: true }, `Secret updated. Click the eye to reveal the new secret.`);
    }

    onDelegateChanged(delegateEnabled) {

        return this.updateApplication({ delegateEnabled });
    }

    onDelegateWhitelistChanged(delegateWhitelistEnabled) {

        return this.updateApplication({ delegateWhitelistEnabled });
    }

    onDelegateWhitelistAdded(ip) {
        const delegateWhitelist = this.state.application.flowManagement.delegate.whitelist.slice();
        delegateWhitelist.push(ip);
        return this.updateApplication({ delegateWhitelist });
    }

    onDelegateWhitelistRemoved(ip) {

        const delegateWhitelist = this.state.application.flowManagement.delegate.whitelist.slice();
        const index = delegateWhitelist.findIndex((ru) => { return ru === ip; });
        if (index >= 0) {
            delegateWhitelist.splice(index, 1);
            return this.updateApplication({ delegateWhitelist });
        }
    }

    onPrivacyIdChanged(privacyId) {
        if (privacyId === '') {
            privacyId = null;
        }
        return this.updateApplication({ privacyId });
    }

    onProviderChanged(authenticationProvider) {

        return this.updateApplication({ authenticationProvider });
    }

    onAppTypeChanged(applicationType) {

        return this.updateApplication({ applicationType });
    }

    onDeleteApplication() {

        this.api.exec(`/user/organizations/${this.props.organizationId}/applications/${this.props.applicationId}`, 'DELETE')
            .then(() => {

                this.setState({ redirect: `/organizations/${this.props.organizationId}` });
            })
            .catch((err) => {

                this.onFailed(err.toString());
            });
    }

    onToggleApplication() {

        return this.updateApplication({
            active: !this.state.application.active
        });
    }

    onImplicitChange(implicit) {

        return this.updateApplication({
            implicit
        });
    }

    onLocaleCountryChanged(localeEnabled) {

        return this.updateApplication({ locale: { countryEnabled: localeEnabled } });
    }

    onLocaleDefaultCountryUpdated(defaultCountry) {

        return this.updateApplication({ locale: { defaultCountry } }, 'Default country updated.');
    }

    onLocaleLanguageChanged(localeEnabled) {

        return this.updateApplication({ locale: { languageEnabled: localeEnabled } });
    }

    onLocaleDefaultLanguageUpdated(defaultLanguage) {

        return this.updateApplication({ locale: { defaultLanguage } }, 'Default language updated.');
    }

    onSmsOptInEnabledChanged(enabled) {

        return this.updateApplication({ smsOptIn: { enabled } });
    }

    onSmsOptInCopyUpdated(copy) {

        return this.updateApplication({ smsOptIn: { copy } }, 'SMS opt-in copy updated.');
    }

    onPhoneNumberCountryAdded(code) {

        const countries = (this.state.application.registration &&
            this.state.application.registration.phoneNumber &&
            this.state.application.registration.phoneNumber.countries
            ? this.state.application.registration.phoneNumber.countries.slice()
            : []);

        if (!countries.includes(code)) {
            countries.push(code);
            return this.updateApplication({ phoneNumber: { countries } });
        }
    }

    onPhoneNumberCountryRemoved(code) {

        const countries = (this.state.application.registration &&
            this.state.application.registration.phoneNumber &&
            this.state.application.registration.phoneNumber.countries
            ? this.state.application.registration.phoneNumber.countries.slice()
            : []);

        const index = countries.indexOf(code);
        if (index >= 0) {
            countries.splice(index, 1);
            return this.updateApplication({ phoneNumber: { countries } });
        }
    }

    onEmailOptInEnabledChanged(enabled) {

        return this.updateApplication({ emailOptIn: { enabled } });
    }

    onEmailOptInCopyUpdated(copy) {

        return this.updateApplication({ emailOptIn: { copy } }, 'Email opt-in copy updated.');
    }

    onPortalSettingChanged(key, value) {

        return this.updateApplication({ portal: { [key]: value } });
    }

    onGuestCheckoutEnabledChanged(enabled) {

        return this.updateApplication({ guestCheckout: { enabled } });
    }

    onFirstNameEnabledChanged(enabled) {

        return this.updateApplication({ firstName: { enabled } });
    }

    onLastNameEnabledChanged(enabled) {

        return this.updateApplication({ lastName: { enabled } });
    }

    onPhoneNumberEnabledChanged(enabled) {

        return this.updateApplication({ phoneNumber: { enabled } });
    }

    onHeaderLogoUrlUpdated(headerLogoUrl) {

        return this.updateApplication({
            displayable: {
                content: {
                    headerLogoUrl
                }
            }
        }, 'Header logo updated.');
    }

    onHeaderBackgroundColorUpdated(headerBackgroundColor) {

        return this.updateApplication({
            displayable: {
                content: {
                    headerBackgroundColor
                }
            }
        }, 'Header background color updated.');
    }

    onButtonColorUpdated(buttonColor) {

        return this.updateApplication({
            displayable: {
                content: {
                    buttonColor
                }
            }
        }, 'Button color updated.');
    }

    onButtonHoverColorUpdated(buttonHoverColor) {

        return this.updateApplication({
            displayable: {
                content: {
                    buttonHoverColor
                }
            }
        }, 'Button hover color updated.');
    }

    onPkceChanged(pkceEnabled) {

        return this.updateApplication({ pkceEnabled });
    }

    onOverrideEmailValidationChanged(overrideEmailValidation) {
        return this.updateApplication({ overrideEmailValidation });
    }

    onPasswordChanged(passwordEnabled) {

        return this.updateApplication({ passwordEnabled });
    }

    onPrivacyPolicyUpdated(link) {

        return this.updateApplication({
            displayable: {
                privacyPolicyUrl: link
            }
        }, 'Privacy policy link updated.');
    }

    onTermsAndConditionsUpdated(link) {

        return this.updateApplication({
            displayable: {
                termsAndConditionsUrl: link
            }
        }, 'Terms and conditions link updated.');
    }

    onTitleUpdated(title) {

        return this.updateApplication({
            displayable: {
                content: {
                    title
                }
            }
        }, 'Portal title updated.');
    }

    onAppIconUpdated(appIconUrl) {

        return this.updateApplication({
            displayable: {
                content: {
                    appIconUrl
                }
            }
        }, 'Application icon updated.');
    }

    onMoreInfoUpdated(link) {

        return this.updateApplication({
            displayable: {
                content: {
                    moreInfoUrl: link
                }
            }
        }, '"More Information" link updated.');
    }

    onSuccess(message) {

        this.setState({ success: message, error: null });
    }

    onFailed(message) {

        this.setState({ success: null, error: message });
    }

    onUpdateStatus(type, message) {

        if (type === 'error') {
            return this.onFailed(message);
        }
        return this.onSuccess(message);
    }

    onPermissionAdded(permission) {

        const permissions = this.state.application.permissions.slice();
        permissions.push(permission);

        return this.updateApplication({ permissions });
    }

    onPermissionRemoved(permission) {

        const permissions = this.state.application.permissions.slice();
        const index = permissions.findIndex((p) => { return p === permission; });
        if (index >= 0) {
            permissions.splice(index, 1);
            return this.updateApplication({ permissions });
        }
    }

    onPassportClientAdded(clientId) {

        const passportClients = this.state.application.passportClients.slice();
        passportClients.push(clientId);

        return this.updateApplication({ passportClients });
    }

    onPassportClientRemoved(clientId) {

        const passportClients = this.state.application.passportClients.slice();
        const index = passportClients.findIndex((c) => { return c === clientId; });
        if (index >= 0) {
            passportClients.splice(index, 1);
            return this.updateApplication({ passportClients });
        }
    }

    componentDidMount() {

        this.api.exec(`/user/organizations/${this.props.organizationId}/applications/${this.props.applicationId}`)
            .then((application) => {

                this.api.exec('/providers')
                    .then((providers) => {

                        this.oauthApi.exec('/user/registration/locale')
                            .then((localeInformation) => {

                                const countries = (localeInformation && localeInformation.countries) || [];
                                const languages = (localeInformation && localeInformation.languages) || [];
                                this.setState({ application, providers, countries, languages, error: null, success: null });
                            })
                            .catch((err) => {

                                this.onFailed(err.toString());
                            });
                    })
                    .catch((err) => {

                        this.onFailed(err.toString());
                    })

            })
            .catch((err) => {

                this.onFailed(err.toString());
            });
    }

    render() {

        if (this.state.redirect) {
            return (<Redirect to={this.state.redirect} />);
        }

        const {
            application,
            providers,
            countries,
            languages
        } = this.state;

        if (!application) {
            return null;
        }

        return (
            <div className="container container-fluid">
                <div className="row">
                    <div className="col-12 text-center">
                        <h3>{application.applicationName}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center">
                        <FormError
                            width="10"
                            offset="1"
                            styles={{ marginTop: '2%' }}
                            message={this.state.success}
                            suppressTitle
                            state="success" />
                        <FormError
                            width="10"
                            offset="1"
                            styles={{ marginTop: '2%' }}
                            message={this.state.error} />
                    </div>
                </div>
                <div className="row" style={{ marginTop: '3%' }}>
                    <div className="col-4">
                        <AppStatusPanel application={application} />
                    </div>
                    <div className="col-8">
                        <AppManagePanel
                            application={application}
                            providers={providers}
                            countries={countries}
                            languages={languages}
                            onAppTypeChanged={this.onAppTypeChanged}
                            onPkceChanged={this.onPkceChanged}
                            onPasswordChanged={this.onPasswordChanged}
                            onOverrideEmailValidationChanged={this.onOverrideEmailValidationChanged}
                            onUpdateStatus={this.onUpdateStatus}
                            onDelegateChanged={this.onDelegateChanged}
                            onDelegateWhitelistChanged={this.onDelegateWhitelistChanged}
                            onDelegateWhitelistAdded={this.onDelegateWhitelistAdded}
                            onDelegateWhitelistRemoved={this.onDelegateWhitelistRemoved}
                            onDomainAdded={this.onDomainAdded}
                            onDomainRemoved={this.onDomainRemoved}
                            onChannelIdChanged={this.onChannelIdChanged}
                            onClientSecretReset={this.onClientSecretReset}
                            onPrivacyIdChanged={this.onPrivacyIdChanged}
                            onProviderChanged={this.onProviderChanged}
                            onImplicitChange={this.onImplicitChange}
                            onLocaleCountryChanged={this.onLocaleCountryChanged}
                            onLocaleDefaultCountryUpdated={this.onLocaleDefaultCountryUpdated}
                            onLocaleLanguageChanged={this.onLocaleLanguageChanged}
                            onLocaleDefaultLanguageUpdated={this.onLocaleDefaultLanguageUpdated}
                            onSmsOptInEnabledChanged={this.onSmsOptInEnabledChanged}
                            onPhoneNumberCountryAdded={this.onPhoneNumberCountryAdded}
                            onPhoneNumberCountryRemoved={this.onPhoneNumberCountryRemoved}
                            onSmsOptInCopyUpdated={this.onSmsOptInCopyUpdated}
                            onEmailOptInEnabledChanged={this.onEmailOptInEnabledChanged}
                            onEmailOptInCopyUpdated={this.onEmailOptInCopyUpdated}
                            onPortalSettingChanged={this.onPortalSettingChanged}
                            onGuestCheckoutEnabledChanged={this.onGuestCheckoutEnabledChanged}
                            onFirstNameEnabledChanged={this.onFirstNameEnabledChanged}
                            onLastNameEnabledChanged={this.onLastNameEnabledChanged}
                            onPhoneNumberEnabledChanged={this.onPhoneNumberEnabledChanged}
                            onHeaderLogoUrlUpdated={this.onHeaderLogoUrlUpdated}
                            onHeaderBackgroundColorUpdated={this.onHeaderBackgroundColorUpdated}
                            onButtonColorUpdated={this.onButtonColorUpdated}
                            onButtonHoverColorUpdated={this.onButtonHoverColorUpdated}
                            onPrivacyPolicyUpdated={this.onPrivacyPolicyUpdated}
                            onTermsAndConditionsUpdated={this.onTermsAndConditionsUpdated}
                            onTitleUpdated={this.onTitleUpdated}
                            onAppIconUpdated={this.onAppIconUpdated}
                            onMoreInfoUpdated={this.onMoreInfoUpdated}
                            onToggleApplication={this.onToggleApplication}
                            onDeleteApplication={this.onDeleteApplication}
                            onPermissionAdded={this.onPermissionAdded}
                            onPermissionRemoved={this.onPermissionRemoved}
                            onPassportClientAdded={this.onPassportClientAdded}
                            onPassportClientRemoved={this.onPassportClientRemoved}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export {
    ApplicationDetailApp
};
